import { axiosInstance, TalkingFaceModelType, VideoDetailsType } from '../../utils';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  avatarId: string;
  text: string;
  audioId: string;
  name: string;
  background?: string;
  processedBackgroundId? : string;
  modelName?: TalkingFaceModelType,
  enableMotion?: boolean,
}

export const createTalkingFaceVideo = async (payload: Payload): Promise<VideoDetailsType> => {
  const res = await axiosInstance.post('/api/videos/create', payload);
  return res.data;
};

// Define options outside the hook to avoid recreating them on each render
const mutationOptions = { 
  onSuccess: (data: VideoDetailsType) => data,
  // Add proper retry logic and error handling
  retry: 0,
  cacheTime: 0 // Don't cache this mutation
};

export const useCreateTalkingFaceVideo = () => {
  return useMutation(createTalkingFaceVideo, mutationOptions);
};
